import JsPdf from 'jspdf'

export async function printSingleLabel (qrCodeDataUrl: string, boarderName: string) {
  const fontData = await fetchFont()

  const pdf = new JsPdf({
    orientation: 'portrait',
  })

  pdf.addFileToVFS('DejaVuSans.ttf', fontData)
  pdf.addFont('DejaVuSans.ttf', 'DejaVu Sans', 'normal')
  pdf.setFont('DejaVu Sans', 'normal')
  pdf.setFontSize(10)

  const splitTextToSize = pdf.splitTextToSize(boarderName, 29)

  if (splitTextToSize.length > 3) {
    pdf.text(splitTextToSize, 33, 18)
  } else if (splitTextToSize.length > 2) {
    pdf.text(splitTextToSize, 33, 22)
  } else if (splitTextToSize.length > 1) {
    pdf.text(splitTextToSize, 33, 26,)
  } else {
    pdf.text(splitTextToSize, 33, 30,)
  }

  pdf.addImage(qrCodeDataUrl, 'png', 3, 3, 27, 27,)

  pdf.save('moj-qr-kod.pdf')
}

async function fetchFont (): Promise<string> {
  const fontFileUrl = require('@/assets/fonts/DejaVuSans.ttf')

  const response = await fetch(fontFileUrl)
  const fontBlob = await response.blob()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = function (event) {
      if (event.target && typeof event.target.result === 'string') {
        const base64Font = event.target.result.split(',')[1]

        resolve(base64Font)
      } else {
        reject(new Error('Failed to read font file as data URL'))
      }
    }

    reader.onerror = function () {
      reject(new Error('Error reading font file'))
    }

    reader.readAsDataURL(fontBlob)
  })
}
